import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable ,  of } from 'rxjs';
import { JaldeeReportService } from './jaldee-report.service';
import { CommonfilterService } from './commonfilter.service';



@Injectable()
export class JaldeeReportResolverService implements Resolve<any> {
  id: any;
  reportDetails: any;
  s3Url: string;
  constructor(private reportService: JaldeeReportService,private commonfilter: CommonfilterService) {
    this.s3Url = this.commonfilter.getS3Url();
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.reportService.getInvoiceDetails(route.params['s3UrlPath']);

  }

}
